import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (currentPage, perPage, search, searchCountry, searchState,searchCity) => {
  return await GET(
    `/admin/masters/pincode?page=${currentPage || 1}&per_page=${perPage || 10
    }&name=${search || ""}&searchCountry=${searchCountry || ""
    }&searchState=${searchState || ""
    }&searchCity=${searchCity || ""
    }`
  );
};

export const findOne = async (id) => {
  return await GET(`/admin/masters/pincode/${id}`);
};

export const Create = async (data) => {
  return await POST(`/admin/masters/pincode`, data);
};

export const Update = async (id, data) => {
  return await PUT(`/admin/masters/pincode/${id}`, data);
};

export const Status = async (id) => {
  return await POST(`/admin/masters/pincode/${id}`);
};

export const Delete = async (id) => {
  return await DELETE(`/admin/masters/pincode/${id}`);
};
